module.exports = __webpack_public_path__ + "img/logo.c3a591cc.svg";